import React, { Component } from 'react';
import PercentageOverview from "../../models/analytics/PercentageOverview";
import {Doughnut} from "react-chartjs-2";
import AnalyticsDoughnutUtils, {AnalyticsDoughnutPalette} from "./AnalyticsDoughnutUtils";

interface PercentageOverviewDoughnutProps {
    percentageOverview: PercentageOverview;
    title: string;
    labels: string[];
}

interface PercentageOverviewDoughnutState {
}

export default class PercentageOverviewDoughnut extends Component<PercentageOverviewDoughnutProps, PercentageOverviewDoughnutState> {
    static displayName = PercentageOverviewDoughnut.name;

    static LABELS_ALWAYS = [
        'Always',
        'Mostly',
        'Not usually',
        'Never',
        'No data'
    ];

    static LABELS_ALL = [
        'All',
        'Most',
        'Some',
        'None',
        'No data'
    ];
    

    constructor(props: PercentageOverviewDoughnutProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {

    }


    componentDidUpdate(prevProps: Readonly<PercentageOverviewDoughnutProps>, prevState: Readonly<PercentageOverviewDoughnutState>, snapshot?: any): void {

    }


    render(): JSX.Element {
        
        const chartOptions = AnalyticsDoughnutUtils.chartOptions(this.props.title);

        const doughnutChartData = {
            labels: this.props.labels,
            datasets: [{
                data: [this.props.percentageOverview.alwaysPercentage.toFixed(2),this.props.percentageOverview.mostlyPercentage.toFixed(2),this.props.percentageOverview.mostlyNotPercentage.toFixed(2),this.props.percentageOverview.neverPercentage.toFixed(2),this.props.percentageOverview.noDataPercentage.toFixed(2)],
                backgroundColor: [
                    AnalyticsDoughnutPalette.blue,
                    AnalyticsDoughnutPalette.green,
                    AnalyticsDoughnutPalette.amber,
                    AnalyticsDoughnutPalette.red,
                    AnalyticsDoughnutPalette.grey
                ]
            }]
        };

        return (
            <div className="doughnut-holder doughnut-holder--medium doughnut-holder--centered">
                <Doughnut data={doughnutChartData} options={chartOptions} height={2} width={4}/>
            </div>
        );
    }
}